/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  DashboardDoughnutModels,
  DashboardDoughnutUseCases,
  DashboardSeverityKpi,
  DashboardSpiderModels,
  DashboardSpiderUseCases,
  DashboardStackedMonthlyVars,
  DashboardUseCaseModelCountShown,
  DashboardUseCaseModelCounts,
  FilterTreeResults,
} from '../models/index';
import {
  DashboardDoughnutModelsFromJSON,
  DashboardDoughnutModelsToJSON,
  DashboardDoughnutUseCasesFromJSON,
  DashboardDoughnutUseCasesToJSON,
  DashboardSeverityKpiFromJSON,
  DashboardSeverityKpiToJSON,
  DashboardSpiderModelsFromJSON,
  DashboardSpiderModelsToJSON,
  DashboardSpiderUseCasesFromJSON,
  DashboardSpiderUseCasesToJSON,
  DashboardStackedMonthlyVarsFromJSON,
  DashboardStackedMonthlyVarsToJSON,
  DashboardUseCaseModelCountShownFromJSON,
  DashboardUseCaseModelCountShownToJSON,
  DashboardUseCaseModelCountsFromJSON,
  DashboardUseCaseModelCountsToJSON,
  FilterTreeResultsFromJSON,
  FilterTreeResultsToJSON,
} from '../models/index';

export interface ApiDashboardModelDoughnutChartDataRetrieveRequest {
  limit: ApiDashboardModelDoughnutChartDataRetrieveLimitEnum;
  aiModels?: Array<string>;
  date?: string;
  departments?: Array<string>;
  useCases?: Array<string>;
}

export interface ApiDashboardModelSpiderChartDataRetrieveRequest {
  limit: ApiDashboardModelSpiderChartDataRetrieveLimitEnum;
  aiModels?: Array<string>;
  date?: string;
  departments?: Array<string>;
  useCases?: Array<string>;
}

export interface ApiDashboardPortfolioFilteredCountsRetrieveRequest {
  aiModels?: Array<string>;
  date?: string;
  departments?: Array<string>;
  useCases?: Array<string>;
}

export interface ApiDashboardPortfolioStackedBarChartDataRetrieveRequest {
  indicators: Array<ApiDashboardPortfolioStackedBarChartDataRetrieveIndicatorsEnum>;
  limit: number;
  aiModels?: Array<string>;
  date?: string;
  departments?: Array<string>;
  useCases?: Array<string>;
}

export interface ApiDashboardPortfolioTotalCountsRetrieveRequest {
  aiModels?: Array<string>;
  date?: string;
  departments?: Array<string>;
  useCases?: Array<string>;
}

export interface ApiDashboardPortfolioTotalRiskRetrieveRequest {
  date?: string;
  departments?: Array<string>;
  useCases?: Array<string>;
}

export interface ApiDashboardUseCaseSpiderChartDataRetrieveRequest {
  limit: ApiDashboardUseCaseSpiderChartDataRetrieveLimitEnum;
  aiModels?: Array<string>;
  date?: string;
  departments?: Array<string>;
  useCases?: Array<string>;
}

export interface ApiDashboardUseCasesDoughnutChartDataRetrieveRequest {
  limit: ApiDashboardUseCasesDoughnutChartDataRetrieveLimitEnum;
  aiModels?: Array<string>;
  date?: string;
  departments?: Array<string>;
  useCases?: Array<string>;
}

/**
 *
 */
export class DashboardApi extends runtime.BaseAPI {
  /**
   */
  async apiDashboardFilterTreeDataRetrieveRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<FilterTreeResults>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dashboard/filter_tree_data/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => FilterTreeResultsFromJSON(jsonValue));
  }

  /**
   */
  async apiDashboardFilterTreeDataRetrieve(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<FilterTreeResults> {
    const response = await this.apiDashboardFilterTreeDataRetrieveRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDashboardModelDoughnutChartDataRetrieveRaw(
    requestParameters: ApiDashboardModelDoughnutChartDataRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DashboardDoughnutModels>> {
    if (requestParameters['limit'] == null) {
      throw new runtime.RequiredError(
        'limit',
        'Required parameter "limit" was null or undefined when calling apiDashboardModelDoughnutChartDataRetrieve().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['aiModels'] != null) {
      queryParameters['ai_models'] = requestParameters['aiModels'];
    }

    if (requestParameters['date'] != null) {
      queryParameters['date'] = requestParameters['date'];
    }

    if (requestParameters['departments'] != null) {
      queryParameters['departments'] = requestParameters['departments'];
    }

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    if (requestParameters['useCases'] != null) {
      queryParameters['use_cases'] = requestParameters['useCases'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dashboard/model_doughnut_chart_data`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => DashboardDoughnutModelsFromJSON(jsonValue));
  }

  /**
   */
  async apiDashboardModelDoughnutChartDataRetrieve(
    requestParameters: ApiDashboardModelDoughnutChartDataRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DashboardDoughnutModels> {
    const response = await this.apiDashboardModelDoughnutChartDataRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDashboardModelSpiderChartDataRetrieveRaw(
    requestParameters: ApiDashboardModelSpiderChartDataRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DashboardSpiderModels>> {
    if (requestParameters['limit'] == null) {
      throw new runtime.RequiredError(
        'limit',
        'Required parameter "limit" was null or undefined when calling apiDashboardModelSpiderChartDataRetrieve().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['aiModels'] != null) {
      queryParameters['ai_models'] = requestParameters['aiModels'];
    }

    if (requestParameters['date'] != null) {
      queryParameters['date'] = requestParameters['date'];
    }

    if (requestParameters['departments'] != null) {
      queryParameters['departments'] = requestParameters['departments'];
    }

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    if (requestParameters['useCases'] != null) {
      queryParameters['use_cases'] = requestParameters['useCases'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dashboard/model_spider_chart_data`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => DashboardSpiderModelsFromJSON(jsonValue));
  }

  /**
   */
  async apiDashboardModelSpiderChartDataRetrieve(
    requestParameters: ApiDashboardModelSpiderChartDataRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DashboardSpiderModels> {
    const response = await this.apiDashboardModelSpiderChartDataRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDashboardPortfolioFilteredCountsRetrieveRaw(
    requestParameters: ApiDashboardPortfolioFilteredCountsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DashboardUseCaseModelCountShown>> {
    const queryParameters: any = {};

    if (requestParameters['aiModels'] != null) {
      queryParameters['ai_models'] = requestParameters['aiModels'];
    }

    if (requestParameters['date'] != null) {
      queryParameters['date'] = requestParameters['date'];
    }

    if (requestParameters['departments'] != null) {
      queryParameters['departments'] = requestParameters['departments'];
    }

    if (requestParameters['useCases'] != null) {
      queryParameters['use_cases'] = requestParameters['useCases'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dashboard/portfolio_filtered_counts`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => DashboardUseCaseModelCountShownFromJSON(jsonValue));
  }

  /**
   */
  async apiDashboardPortfolioFilteredCountsRetrieve(
    requestParameters: ApiDashboardPortfolioFilteredCountsRetrieveRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DashboardUseCaseModelCountShown> {
    const response = await this.apiDashboardPortfolioFilteredCountsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDashboardPortfolioStackedBarChartDataRetrieveRaw(
    requestParameters: ApiDashboardPortfolioStackedBarChartDataRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DashboardStackedMonthlyVars>> {
    if (requestParameters['indicators'] == null) {
      throw new runtime.RequiredError(
        'indicators',
        'Required parameter "indicators" was null or undefined when calling apiDashboardPortfolioStackedBarChartDataRetrieve().',
      );
    }

    if (requestParameters['limit'] == null) {
      throw new runtime.RequiredError(
        'limit',
        'Required parameter "limit" was null or undefined when calling apiDashboardPortfolioStackedBarChartDataRetrieve().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['aiModels'] != null) {
      queryParameters['ai_models'] = requestParameters['aiModels'];
    }

    if (requestParameters['date'] != null) {
      queryParameters['date'] = requestParameters['date'];
    }

    if (requestParameters['departments'] != null) {
      queryParameters['departments'] = requestParameters['departments'];
    }

    if (requestParameters['indicators'] != null) {
      queryParameters['indicators'] = requestParameters['indicators'];
    }

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    if (requestParameters['useCases'] != null) {
      queryParameters['use_cases'] = requestParameters['useCases'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dashboard/portfolio_stacked_bar_chart_data`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => DashboardStackedMonthlyVarsFromJSON(jsonValue));
  }

  /**
   */
  async apiDashboardPortfolioStackedBarChartDataRetrieve(
    requestParameters: ApiDashboardPortfolioStackedBarChartDataRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DashboardStackedMonthlyVars> {
    const response = await this.apiDashboardPortfolioStackedBarChartDataRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDashboardPortfolioTotalCountsRetrieveRaw(
    requestParameters: ApiDashboardPortfolioTotalCountsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DashboardUseCaseModelCounts>> {
    const queryParameters: any = {};

    if (requestParameters['aiModels'] != null) {
      queryParameters['ai_models'] = requestParameters['aiModels'];
    }

    if (requestParameters['date'] != null) {
      queryParameters['date'] = requestParameters['date'];
    }

    if (requestParameters['departments'] != null) {
      queryParameters['departments'] = requestParameters['departments'];
    }

    if (requestParameters['useCases'] != null) {
      queryParameters['use_cases'] = requestParameters['useCases'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dashboard/portfolio_total_counts`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => DashboardUseCaseModelCountsFromJSON(jsonValue));
  }

  /**
   */
  async apiDashboardPortfolioTotalCountsRetrieve(
    requestParameters: ApiDashboardPortfolioTotalCountsRetrieveRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DashboardUseCaseModelCounts> {
    const response = await this.apiDashboardPortfolioTotalCountsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDashboardPortfolioTotalRiskRetrieveRaw(
    requestParameters: ApiDashboardPortfolioTotalRiskRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DashboardSeverityKpi>> {
    const queryParameters: any = {};

    if (requestParameters['date'] != null) {
      queryParameters['date'] = requestParameters['date'];
    }

    if (requestParameters['departments'] != null) {
      queryParameters['departments'] = requestParameters['departments'];
    }

    if (requestParameters['useCases'] != null) {
      queryParameters['use_cases'] = requestParameters['useCases'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dashboard/portfolio_total_risk`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => DashboardSeverityKpiFromJSON(jsonValue));
  }

  /**
   */
  async apiDashboardPortfolioTotalRiskRetrieve(
    requestParameters: ApiDashboardPortfolioTotalRiskRetrieveRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DashboardSeverityKpi> {
    const response = await this.apiDashboardPortfolioTotalRiskRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDashboardUseCaseSpiderChartDataRetrieveRaw(
    requestParameters: ApiDashboardUseCaseSpiderChartDataRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DashboardSpiderUseCases>> {
    if (requestParameters['limit'] == null) {
      throw new runtime.RequiredError(
        'limit',
        'Required parameter "limit" was null or undefined when calling apiDashboardUseCaseSpiderChartDataRetrieve().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['aiModels'] != null) {
      queryParameters['ai_models'] = requestParameters['aiModels'];
    }

    if (requestParameters['date'] != null) {
      queryParameters['date'] = requestParameters['date'];
    }

    if (requestParameters['departments'] != null) {
      queryParameters['departments'] = requestParameters['departments'];
    }

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    if (requestParameters['useCases'] != null) {
      queryParameters['use_cases'] = requestParameters['useCases'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dashboard/use_case_spider_chart_data`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => DashboardSpiderUseCasesFromJSON(jsonValue));
  }

  /**
   */
  async apiDashboardUseCaseSpiderChartDataRetrieve(
    requestParameters: ApiDashboardUseCaseSpiderChartDataRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DashboardSpiderUseCases> {
    const response = await this.apiDashboardUseCaseSpiderChartDataRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDashboardUseCasesDoughnutChartDataRetrieveRaw(
    requestParameters: ApiDashboardUseCasesDoughnutChartDataRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DashboardDoughnutUseCases>> {
    if (requestParameters['limit'] == null) {
      throw new runtime.RequiredError(
        'limit',
        'Required parameter "limit" was null or undefined when calling apiDashboardUseCasesDoughnutChartDataRetrieve().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['aiModels'] != null) {
      queryParameters['ai_models'] = requestParameters['aiModels'];
    }

    if (requestParameters['date'] != null) {
      queryParameters['date'] = requestParameters['date'];
    }

    if (requestParameters['departments'] != null) {
      queryParameters['departments'] = requestParameters['departments'];
    }

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    if (requestParameters['useCases'] != null) {
      queryParameters['use_cases'] = requestParameters['useCases'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dashboard/use_cases_doughnut_chart_data`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => DashboardDoughnutUseCasesFromJSON(jsonValue));
  }

  /**
   */
  async apiDashboardUseCasesDoughnutChartDataRetrieve(
    requestParameters: ApiDashboardUseCasesDoughnutChartDataRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DashboardDoughnutUseCases> {
    const response = await this.apiDashboardUseCasesDoughnutChartDataRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const ApiDashboardModelDoughnutChartDataRetrieveLimitEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
} as const;
export type ApiDashboardModelDoughnutChartDataRetrieveLimitEnum =
  (typeof ApiDashboardModelDoughnutChartDataRetrieveLimitEnum)[keyof typeof ApiDashboardModelDoughnutChartDataRetrieveLimitEnum];
/**
 * @export
 */
export const ApiDashboardModelSpiderChartDataRetrieveLimitEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
} as const;
export type ApiDashboardModelSpiderChartDataRetrieveLimitEnum =
  (typeof ApiDashboardModelSpiderChartDataRetrieveLimitEnum)[keyof typeof ApiDashboardModelSpiderChartDataRetrieveLimitEnum];
/**
 * @export
 */
export const ApiDashboardPortfolioStackedBarChartDataRetrieveIndicatorsEnum = {
  explainability: 'explainability',
  fairness: 'fairness',
  performance: 'performance',
  robustness: 'robustness',
} as const;
export type ApiDashboardPortfolioStackedBarChartDataRetrieveIndicatorsEnum =
  (typeof ApiDashboardPortfolioStackedBarChartDataRetrieveIndicatorsEnum)[keyof typeof ApiDashboardPortfolioStackedBarChartDataRetrieveIndicatorsEnum];
/**
 * @export
 */
export const ApiDashboardUseCaseSpiderChartDataRetrieveLimitEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
} as const;
export type ApiDashboardUseCaseSpiderChartDataRetrieveLimitEnum =
  (typeof ApiDashboardUseCaseSpiderChartDataRetrieveLimitEnum)[keyof typeof ApiDashboardUseCaseSpiderChartDataRetrieveLimitEnum];
/**
 * @export
 */
export const ApiDashboardUseCasesDoughnutChartDataRetrieveLimitEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
} as const;
export type ApiDashboardUseCasesDoughnutChartDataRetrieveLimitEnum =
  (typeof ApiDashboardUseCasesDoughnutChartDataRetrieveLimitEnum)[keyof typeof ApiDashboardUseCasesDoughnutChartDataRetrieveLimitEnum];
